module.exports = __webpack_public_path__ + "ui-static/img/external-vms-no-items_light.bccac8e3.svg";